import { FileImport } from '@/shared/app/model/templating/FileImport';

import Dataset from '@/shared/data/model/Dataset';
import bio_certif from './bio_certif.png';
import la_region_du_gout from './la_region_du_gout.png';
import label_rouge from './label_rouge.png';
import nouvelle_recette from './nouvelle_recette.png';
import par_nos_soins from './par_nos_soins.png';
import poisson_frais from './poisson_frais.png';
import porc_francais from './porc_francais.png';
import produit_bio from './produit_bio.png';
import produit_eco from './produit_eco.png';
import produit_frais from './produit_frais.png';
import produit_local from './produit_local.png';
import produit_vege from './produit_vege.png';
import vbf from './vbf.png';
import volaille_francaise from './volaille_francaise.png';

export const ORIGINS_ICONS: { [key: string]: FileImport } = {
  bio_certif,
  la_region_du_gout,
  label_rouge,
  nouvelle_recette,
  par_nos_soins,
  porc_francais,
  poisson_frais,
  produit_eco,
  produit_bio,
  produit_frais,
  produit_local,
  produit_vege,
  vbf,
  volaille_francaise,
};

export const ORIGINS_ICONS_SCOLLER: Dataset = {
  bio_certif: `${bio_certif}|Agriculture biologique`,
  la_region_du_gout: `${la_region_du_gout}|La région du goût`,
  label_rouge: `${label_rouge}|Label Rouge`,
  nouvelle_recette: `${nouvelle_recette}|Nouvel recette`,
  par_nos_soins: `${par_nos_soins}|Réalisé par nos soins`,
  porc_francais: `${porc_francais}|Porc français`,
  poisson_frais: `${poisson_frais}|Poisson frais`,
  produit_eco: `${produit_eco}|Produit éco`,
  produit_bio: `${produit_bio}|Produit Bio`,
  produit_frais: `${produit_frais}|Produit Frais`,
  produit_local: `${produit_local}|Produit Local`,
  produit_vege: `${produit_vege}|Produit Végétarien`,
  vbf: `${vbf}|Viande de Boeuf Française`,
  volaille_francaise: `${volaille_francaise}|Volaille française`,
};
